<template>
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 32 32"
    fill="none"
  >
    <title>infor-card</title>
    <path
      stroke-linejoin="miter"
      stroke-linecap="butt"
      stroke-miterlimit="4"
      stroke-width="2.4"
      :stroke="color"
      d="M5.664 5.516h20.672c1.712 0 3.101 1.388 3.101 3.101v14.766c0 1.712-1.388 3.101-3.101 3.101h-20.672c-1.712 0-3.101-1.388-3.101-3.101v-14.766c0-1.713 1.388-3.101 3.101-3.101z"
    />
    <path
      :fill="color"
      d="M11.275 16c1.623 0 2.953-1.33 2.953-2.953s-1.33-2.953-2.953-2.953-2.953 1.33-2.953 2.953c0 1.623 1.33 2.953 2.953 2.953zM5.664 19.33c1.214 1.682 3.273 2.576 5.611 2.576s4.397-0.898 5.611-2.576c-0.045-1.767-3.741-2.74-5.611-2.74s-5.566 0.973-5.611 2.74z"
    />
    <path
      :fill="color"
      d="M18.953 11.57h7.383v2.953h-7.383v-2.953z"
    />
    <path
      :fill="color"
      d="M20.43 17.477h5.906v2.953h-5.906v-2.953z"
    />
  </svg>
</template>

<script>
export default {
  name: 'SvgWebsite',
  props: {
    color: {
      type: String,
      default () {
        return '#fff'
      }
    }
  }
}
</script>
